<ion-content scrollY="false">

  @if (cart) {
    <ion-list lines="full">
      <ion-item button="true" (click)="presentCustomerModal()">
        <ion-label><fa-icon [icon]="['fal', 'user']" size="lg" [fixedWidth]="true"></fa-icon>
        @if (!cart.person) {
          <span>Add customer</span>
        }
        @if (cart.person) {
          <span>Change customer</span>
        }
      </ion-label>
    </ion-item>
    @if (permissionService.isPermitted('pos-sell-change-pricing-tier') && pricing_tiers && pricing_tiers.length > 1) {
      <ion-item button="true" (click)="presentPricingTierModal()">
        <ion-label><fa-icon [icon]="['fal', 'layer-group']" size="lg" [fixedWidth]="true"></fa-icon>Change pricing tier</ion-label>
      </ion-item>
    }
    @if (permissionService.isPermitted('pos-sell-change-currency') && supported_currencies && supported_currencies.length > 1) {
      <ion-item button="true" (click)="presentCurrencyModal()">
        <ion-label><fa-icon [icon]="['fal', 'money-bill-alt']" size="lg" [fixedWidth]="true"></fa-icon>Change currency</ion-label>
      </ion-item>
    }
    <ion-item button="true" (click)="presentAdditionalInfoModal()">
      <ion-label><fa-icon [icon]="['fal', 'paperclip']" size="lg" [fixedWidth]="true"></fa-icon>
      @if (!cart.special_instructions && !cart.customer_note && !cart.internal_note) {
        <span>Add additional info</span>
      }
      @if (cart.special_instructions || cart.customer_note || cart.internal_note) {
        <span>Update additional info</span>
      }
    </ion-label>
  </ion-item>
  @if (permissionService.isPermitted('pos-sell-add-pickup') && !cart.pickup) {
    <ion-item button="true" (click)="presentPickupModal()">
      <ion-label><fa-icon [icon]="['fal', 'hand-holding-box']" size="lg" [fixedWidth]="true"></fa-icon>Add pickup</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-edit-pickup') && cart.pickup) {
    <ion-item button="true" (click)="presentPickupModal()">
      <ion-label><fa-icon [icon]="['fal', 'hand-holding-box']" size="lg" [fixedWidth]="true"></fa-icon>Update pickup</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-add-shipping') && !cart.shipping_address) {
    <ion-item button="true" (click)="presentShippingModal()">
      <ion-label><fa-icon [icon]="['fal', 'truck']" size="lg" [fixedWidth]="true"></fa-icon>Add shipping</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-edit-shipping') && cart.shipping_address) {
    <ion-item button="true" (click)="presentShippingModal()">
      <ion-label><fa-icon [icon]="['fal', 'truck']" size="lg" [fixedWidth]="true"></fa-icon>Update shipping</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-open-cash-drawer') && (receipt_printer || desktop_print_client_enabled)) {
    <ion-item button="true" (click)="openCashDrawer()">
      <ion-label><fa-icon [icon]="['fal', 'money-from-bracket']" size="lg" [fixedWidth]="true"></fa-icon>Open cash drawer</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-quotes-add-quote') && online && cart.items.length > 0 && !cart.quote_id) {
    <ion-item button="true" (click)="presentQuoteModal()">
      <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>Create quote</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-quotes-edit-quote') && online && cart.items.length > 0 && cart.quote_id && (quote && ['draft','sent','declined'].includes(quote.status))) {
    <ion-item button="true" (click)="presentQuoteModal()">
      <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>Update quote</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-parked-carts-add-parked-cart') && online && cart.items.length && !cart.quote_id) {
    <ion-item button="true" (click)="presentParkCartModal()">
      <ion-label><fa-icon [icon]="['fal', 'cart-arrow-down']" size="lg" [fixedWidth]="true"></fa-icon>Park</ion-label>
    </ion-item>
  }
  @if (permissionService.isPermitted('pos-sell-edit-item-discount') && cart.items.length) {
    <ion-item button="true" (click)="presentDiscountCartModal()">
      <ion-label><fa-icon [icon]="['fal', 'cut']" size="lg" [fixedWidth]="true"></fa-icon>Change discount</ion-label>
    </ion-item>
  }
  @if (cart.items.length || cart.special_instructions || cart.customer_note || cart.internal_note || cart.person || cart.shipping_address || cart.pickup) {
    <ion-item button="true" (click)="presentClearCartConfirmation()">
      <ion-label><fa-icon [icon]="['fal', 'trash-alt']" size="lg" [fixedWidth]="true"></fa-icon>Clear</ion-label>
    </ion-item>
  }
</ion-list>
}

</ion-content>